import commentsService from '@rd-web-markets/shared/dist/services/comments.service';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import CommentsSection from './CommentsSection';
import { Button } from '../../../buttons';
import { Modal } from '../../..';
import { handleError } from '../../../../store/features/alertSlice';

/**
 * !! README !!:
 * 
 * http://help.dottoro.com/ljlabctr.php
 * 
 * The anchor point is the point where the process of selecting was started. The anchor node is the deepest node in the DOM hierarchy that contains the anchor point.
 * In most cases, the anchorNode property refers to a TextNode.
 * In that case, the anchorOffset property returns the character position within the text content of the anchor node, where the selection begins.
 * However, in some cases (for example when the entire contents of the page are selected with Ctrl+A) the anchorNode property refers to a node that can have child nodes.
 * In that case, the anchorOffset property returns the index in the childNodes collection of the anchor node, where the selection begins. See the example for details.
 * Note that if the anchor point is placed after the focus point, then the anchor point is not part of the selection (it is the first position after), therefore the value returned by the anchorOffset property can be equal to the length of the text content or childNodes collection of the anchor node.
 * 
 * 
 * Therefore we user Selection.getRangeAt(0).startOffset and Selection.getRangeAt(0).endOffset.
 * There can only be a single range in a selection. Selection.getRangeAt(1) is invalid.
 */
const RndCommentsModal = _ref => {
  let {
    onHide,
    show,
    commentTextSelectionData,
    onCreateComment
  } = _ref;
  const NEW_COMMENT_SPAN_ID = uuidv4();
  const [newCommentText, setNewCommentText] = useState('');
  const [comments, setComments] = useState([]);
  const dispatch = useDispatch();
  function findModelIds(spanElement) {
    let parent = spanElement.parentElement;
    while (!parent.className.includes('js-hook')) {
      parent = parent.parentElement;
    }
    const reportTemplateId = parent.className.split('-Report-Template-')?.[1]?.split('-')?.[0];
    const reportTemplateCategoryId = parent.className.split('-category-')?.[1]?.split(' ')?.[0];
    const claimGroupId = parent.className.split('-Claim-Group-')?.[1]?.split('-')?.[0];
    const projectId = parent.className.split('-Project-')?.[1]?.split('-')?.[0];
    const sliceId = parent.className.split('-Slice-')?.[1]?.split('-')?.[0];
    return {
      reportTemplateId,
      reportTemplateCategoryId,
      claimGroupId,
      projectId,
      sliceId
    };
  }
  const {
    reportTemplateCategoryId,
    reportTemplateId,
    claimGroupId,
    projectId,
    sliceId
  } = findModelIds(commentTextSelectionData.anchorNode || commentTextSelectionData.clickedCommentSpan);
  useEffect(() => {
    const fetchComments = async () => {
      try {
        if (commentTextSelectionData.clickedCommentSpan) {
          const result = await commentsService.all(sliceId ? sliceId : reportTemplateCategoryId, sliceId ? 'ProjectReportSlice' : 'ReportTemplateCategory', commentTextSelectionData.clickedCommentSpan.getAttribute('data-aym-comment-id'));
          setComments(result.comments);
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    };
    fetchComments();
  }, [commentTextSelectionData.clickedCommentSpan, dispatch, reportTemplateCategoryId, sliceId]);
  const body = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12,
      style: {
        paddingRight: '5px'
      }
    }, /*#__PURE__*/React.createElement(CommentsSection, {
      comments: comments
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "mt-5"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 11
    }, /*#__PURE__*/React.createElement(Form.Control, {
      style: {
        resize: 'none'
      },
      as: "textarea",
      rows: "3",
      size: "sm",
      value: newCommentText,
      onChange: e => setNewCommentText(e.target.value)
    })), /*#__PURE__*/React.createElement(Col, {
      md: 1
    }, /*#__PURE__*/React.createElement(Button, {
      icon: "chevron_right",
      onClick: () => {
        createComment(commentTextSelectionData.clickedCommentSpan?.getAttribute('data-aym-comment-id'));
      },
      loading: commentBtnLoading,
      showLoadingText: false
    }))))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: "Comments",
    renderBody: () => body(),
    onHide: onHide,
    closeText: "Close"
  });
};
export default RndCommentsModal;